import { roundValue, safeParseFloat } from "lib/number";
import { PLAN_ROWS } from "../formulas/formula-plan-rows";
import { UNITS } from "../formulas/formula-units";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";

export const AVERAGE_DEPTH = ({ factoryOptions, getterParams }) => {
    const totalUnits = referenceMetricValueOrCompute(
        () => {
            let totalUnits = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                totalUnits +=
                    UNITS({
                        factoryOptions,
                        getterParams: {
                            ...getterParams,
                            node: rowNode,
                            data: rowNode.data,
                        },
                    }) ?? 0;
            });

            return totalUnits;
        },
        getterParams,
        MetricsKind.UNITS,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    const planRows = referenceMetricValueOrCompute(
        () => {
            let total = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                total += PLAN_ROWS({
                    factoryOptions,
                    getterParams: {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    },
                });
            });

            return total;
        },
        getterParams,
        MetricsKind.PLAN_ROWS,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    const averageUnits = safeParseFloat(totalUnits / planRows, 0);
    const roundedValue = roundValue(averageUnits, 1);
    if (roundedValue === 0) {
        return "";
    }
    return roundedValue;
};
